import React from 'react';
import FormWizard from '../FormWizard';
import DrugAlcoholPolicyForm from './DrugAlcoholPolicyForm';

const DrugAlcoholPolicyFormPage = () => {
  return (
    <FormWizard 
      formId={11}
      formTitle="Drug & Alcohol Policy"
      formTitleEs="Política de Drogas y Alcohol"
    >
      <DrugAlcoholPolicyForm />
    </FormWizard>
  );
};

export default DrugAlcoholPolicyFormPage;

